import { type CSSProperties, type FC, type TdHTMLAttributes, useContext } from 'react';

import { TableContext } from '../table-context';
import { Text, type TypographyVariant } from '@shared/ui/antd';

export type TCellTextProps = TdHTMLAttributes<HTMLTableCellElement> & {
  index?: number;
  variant?: TypographyVariant;
  fontWeight?: React.CSSProperties['fontWeight'];
  textStyle?: CSSProperties;
};

export const TCellText: FC<TCellTextProps> = ({
  children,
  variant = 'md',
  fontWeight = 400,
  index,
  textStyle,
  ...props
}) => {
  const { columnsConfiguration } = useContext(TableContext);

  const column = index === undefined ? null : columnsConfiguration[index];
  const width = column?.width;

  return (
    <td style={{ width }} {...props}>
      <Text variant={variant} fontWeight={fontWeight} style={textStyle}>
        {children}
      </Text>
    </td>
  );
};
